<template>
    <div class="modal--header">
        <span class="title">
            <slot />
        </span>
    </div>
</template>

<script>
export default {
    name: 'ModalHeader'
};
</script>
